import {
  DateTimePicker,
  InputFormCallout,
  InputFormCalloutProps,
  RadioGroup,
  RadioGroupOption,
  TextInput,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Settings, SettingsContext } from "../../console/SettingsContext";
import { CalloutTestIds } from "../../constants/uiConstants";
import { BackupRestoreType } from "../../helpers/resourceHelper";

export enum Fields {
  Type = "type",
  SCN = "scn",
  Timestamp = "timestamp",
}

export enum FieldsTestIds {
  Type = "type-test",
  SCN = "scn-test",
  Timestamp = "timestamp-test",
}

export enum RestoreTypeOptionsTestIds {
  Latest = "latest-option",
  Timestamp = "timestamp-option",
  SCN = "scn-option",
}

export type BackupRestorePanelProps = Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit" | "componentRef">;

const defaultRestoreType = BackupRestoreType.LATEST;
const restoreTypeOptions = (): RadioGroupOption[] => ([
  {
    testId: RestoreTypeOptionsTestIds.Latest,
    id: BackupRestoreType.LATEST,
    text: Messages.labels.backupRestoreLatest(),
  },
  {
    testId: RestoreTypeOptionsTestIds.Timestamp,
    id: BackupRestoreType.TIMESTAMP,
    text: Messages.labels.backupRestoreTimestamp(),
  },
  {
    testId: RestoreTypeOptionsTestIds.SCN,
    id: BackupRestoreType.SCN,
    text: Messages.labels.backupRestoreSCN(),
  },
] as RadioGroupOption[]);

export const BackupRestorePanel = ({
  targetId,
  componentRef,
  onClose,
  onSubmit,
}: BackupRestorePanelProps): JSX.Element => {
  const [restoreType, setRestoreType] = React.useState<string>(defaultRestoreType);
  const { locale } = React.useContext<Settings>(SettingsContext);
  return (
    <InputFormCallout
      testId={CalloutTestIds.BackupRestorePanel}
      componentRef={componentRef}
      title={Messages.createNewPanels.restore.title()}
      targetId={targetId}
      onClose={onClose}
      onSubmit={onSubmit}
      primaryButtonText={Messages.actions.restore()}
    >
      <RadioGroup
        testId={FieldsTestIds.Type}
        fieldName={Fields.Type}
        options={restoreTypeOptions()}
        defaultValue={defaultRestoreType}
        onChange={setRestoreType}
      />
      {restoreType === BackupRestoreType.TIMESTAMP && (
      <DateTimePicker locale={locale} fieldName={Fields.Timestamp} testId={FieldsTestIds.Timestamp} />
      )}
      {restoreType === BackupRestoreType.SCN && (
      <TextInput
        testId={FieldsTestIds.SCN}
        required
        fieldName={Fields.SCN}
      />
      )}
    </InputFormCallout>
  );
};
